'use client';

import React from 'react';
import { useTranslation } from 'react-i18next';

import icon1 from '../../assets/images/icon1.svg';
import icon2 from '../../assets/images/icon2.svg';
import icon3 from '../../assets/images/icon3.svg';
import icon4 from '../../assets/images/icon4.svg';
import icon5 from '../../assets/images/icon5.svg';
import business from '../../assets/images/BusinessSetup.png';

const BusinessSetup = () => {
  const { t } = useTranslation();

  const steps = [
    { icon: icon1, title: t('upload_documents') },
    { icon: icon2, title: t('complete_authorizations') },
    { icon: icon3, title: t('obtain_license') },
    { icon: icon4, title: t('apply_residency') },
    { icon: icon5, title: t('bank_account_ready') },
  ];

  return (
    <section className="busienss_setup">
      <div className="container">
        {/* Header */}
        <div className="row">
          <div className="col-md-12 text-center">
            <div className="content_wrapper">
              <h2>
                {t('launch_your')} <span className="text-red">{t('uae')}</span>{' '}
                {t('business_with')}{' '}
                <span className="text-red">{t('ease')}</span>
              </h2>
            </div>
          </div>
        </div>

        {/* Mobile Only Content */}
        <div className="mobile-only">
          <div className="d-flex flex-column align-items-center">
            {steps.map((step, index) => (
              <div className="text-center mb-4" key={index}>
                <h5 className="fw-bold text-dark mb-3">{step.title}</h5>
                <div className="icon mb-2">
                  <img src={step.icon} alt={step.title} className="icon-img" />
                </div>
                {index < steps.length && <div className="divider mb-4"></div>}
              </div>
            ))}
          </div>
        </div>

        {/* Desktop Only Content */}
        <div className="desktop-only">
          <div className="setup_boxes">
            <div className="boxes_wrappes">
              <div className="content_info">
                <h3>{t('upload_documents')}</h3>
                <div className="icon">
                  <img
                    src={icon1}
                    alt={t('upload_documents')}
                    className="icon-img"
                  />
                </div>
              </div>
            </div>

            <div className="boxes_wrappes">
              <div className="top_box">
                <div className="icon">
                  <img
                    src={icon2}
                    alt={t('complete_authorizations')}
                    className="icon-img"
                  />
                </div>
                <h3>{t('complete_authorizations')}</h3>
              </div>
            </div>

            <div className="boxes_wrappes">
              <div className="content_info">
                <h3>{t('obtain_license')}</h3>
                <div className="icon">
                  <img
                    src={icon3}
                    alt={t('obtain_license')}
                    className="icon-img"
                  />
                </div>
              </div>
            </div>

            <div className="boxes_wrappes">
              <div className="top_box">
                <div className="icon">
                  <img
                    src={icon4}
                    alt={t('apply_residency')}
                    className="icon-img"
                  />
                </div>
                <h3>{t('apply_residency')}</h3>
              </div>
            </div>

            <div className="boxes_wrappes">
              <div className="content_info">
                <h3>{t('bank_account_ready')}</h3>
                <div className="icon">
                  <img
                    src={icon5}
                    alt={t('bank_account_ready')}
                    className="icon-img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Styles */}
      <style>{`
        .busienss_setup .icon-img {
          width: 80px;
          height: auto;
          max-width: 100%;
        }

        .mobile-only {
          display: none;
        }

        .desktop-only {
          display: block;
        }

        .divider {
          height: 4px;
          width: 150px;
          background-color: #d72626;
          margin: 0 auto;
        }

        @media (max-width: 768px) {
          .mobile-only {
            display: block;
            margin-top: 20px;
          }

          .desktop-only {
            display: none;
          }

          .busienss_setup .icon-img {
            width: 70px;
            padding-bottom: 25px;
            padding-top: 10px;
          }

          .divider {
          // margin-top:10px;
            width: 200px;
          }
        }
      `}</style>
    </section>
  );
};

export default BusinessSetup;
